export const ROLES = ["super_admin", "assistant", "principal", "admin", "pending"];
export const isSuper = (u) => u?.role === "super_admin";
export const isManager = (u) => u?.role === "super_admin" || u?.role === "assistant";
export const canEdit = (u) => ["super_admin", "assistant", "admin"].includes(u?.role);
export const isPending = (u) => !!u && !["super_admin", "assistant", "principal", "admin"].includes(u.role);
